const loadCoords = 0;
const latitude = 0;
const longitude = 0;
declare let bpdStep: number;
declare let pagebaseDelId: number;
declare let jsVariablePaymentPrices: string;
declare let externalMethodToFancy: boolean;
declare let dropin: any;
declare let AT_OrderXhrPool: [any];
declare function ExternalDeliveryLinkFunction(
    anchor: object,
    pedvId: string,
    e: object,
    anchorClick: boolean
): void;
declare function setAdrressInputValidation(): void;
declare function AjaxFancy(e: object): boolean;
declare function startCheckout(): void;
declare function ZipIsAllowedAll(): void;
declare function GA4TransportChange(): void;
declare function GA4PaymentChange(): void;
declare function waitForElementOnce(selector, callback, root): void;


function globalRunOnBasket2() {

    // nastaveni vazeb platby k doprave
    setPayment();
    checkSingleDelivery();
    checkSinglePayment();
    if (!externalMethodToFancy && $(".delivery-info:visible").length == 0) {
        checkExternalDelivery();
    }
    checkExternalPayments();

    $(".block--show span").on("click", function (e) {
        const p = $(this).parents(".sh");
        $(this).parents(".block--show").remove();

        if ($(p).hasClass("active")) return;

        $(p).toggleClass("active");

        const setOn = !$(p).hasClass("active");

        if (setOn) {
            $(p)
                .find(".dynamic")
                .not(".active")
                .not(".hide")
                .each(function (i) {
                    SetDynamicShowHide($(this), true, true);
                });
        } else {
            $(p)
                .find(".dynamic")
                .each(function (i) {
                    SetDynamicShowHide($(this), false, true);
                });
        }
    });

    // ulozeni dopravy a platby
    savepaydel(false);

    $('input[name="delpaymentD"]').on("click", function () {
        AT_OrderXhrPoolAbortAll();
        const delVal = $(this).val();
        const anchor = $(this).closest("li");
        if (anchor.hasClass("deliverypoint")) {
            $.fancybox.close();
            var Request = $.ajax({
                type: "GET",
                url: "/ajax/layerContent.aspx?type=deliverypoint&ps=",
                cache: false,
                async: false,
                dataType: "html",
                success: function (data) {

                    //checknu jestli je furt vybrana doprava ta pro kterou se delal ajax
                    if (delVal !== $("input[name='delpaymentD']:checked").val()
                        &&
                        !$("input[name='delpaymentD']:checked").closest(".active")) {
                        preloader(false);
                        return;
                    }
                    
                    Fancybox.show(
                        [
                            {
                                html: data,
                                type: "html"
                            },
                        ],
                        {
                            dragToClose: false,
                            Carousel: {
                                gestures: false // disables drag/swipe
                            },
                            trapFocus: false,
                            mainClass: "fancybox__container fancybox-delivery__deliveryPoint is-ready",
                            Toolbar: { display: [] },
                            on: {
                                "Carousel.ready": (fancyboxRef, carouselRef, slide) => {
                                    var container = fancyboxRef.getContainer();

                                    if ($(container).find(".fancybox__contentInner").length) {
                                        return true;
                                    }
                                    
                                    fancyboxRef.getContainer().querySelectorAll(".is-close-button").forEach(el => el.remove());

                                    waitForElementOnce(".f-html", function ($html) {
                                        $html.wrapInner("<div class='fancybox__contentInner'></div>");
                                        let html = $(".f-html").html();
                                        parseScript(html);
                                    }, container);
                                },
                                close: () => {
                                    setPayment();
                                }                                    
                            }                            
                        }
                    )

                    preloader(false);


                    if (anchor.prop("class").indexOf("deliverytimeIcoHelp") > -1) {
                        savepaydel(false);
                    }
                }
            });

            return;
        }

        setPayment();
        //writeDPprice();
        checkExternalPayments();
        checkExternalDelivery();
        savepaydel(false);

        // Odstranění hlášky o nevybrané dopravě/platbě
        $("#MsgNotChosenPayDel").remove();
        $("#ulozenkaInfo").hide();
        $("#meestInfo").hide();
        $("#meestPostomatInfo").hide();
        $("#novapostaInfo").hide();
    });

    $("input[type=radio][name='delpaymentD']").on("change", function () {
        $(".isrequire, .isrequireok, .ajax-check-result").remove();
        $(".is-not-valid").removeClass("is-not-valid");
        GA4TransportChange();
    });

    $('input[name="delpaymentP"]').on("click", function () {
        AT_OrderXhrPoolAbortAll();
        //writeDPprice();
        checkExternalPayments();
        savepaydel(false);
        // Odstranění hlášky o nevybrané dopravě/platbě
        $("#MsgNotChosenPayDel").remove();
    });

    $("input[type=radio][name='delpaymentP']").on("change", function () {
        GA4PaymentChange();
    });

    let $timPayType = null;
    let payTypeVal = "";
    if ($("#PayuPaymentBlock").length) {
        $('input[name="pay_type"]').on("click", function () {
            if ($timPayType != null) clearTimeout($timPayType);
            payTypeVal = $(this).val().toString();
            $timPayType = setTimeout(function () {
                const payVal = $("input[name='delpaymentP']:checked").val();
                const delVal = $("input[name='delpaymentD']:checked").val();

                if ($("#pevId" + delVal + "-" + payVal).length) {
                    $("#pevId" + delVal + "-" + payVal).val(payTypeVal);
                }
                savepaydel(false);
            }, 100);
        });
        $('#PayuPaymentBlock a[href^="javascript:PlnSel"]').on(
            "click",
            function (e) {
                e.preventDefault();
                $(this)
                    .parents("tr")
                    .find('input[name="pay_type"]')
                    .trigger("click");
                return false;
            }
        );
    }

    // kontrola na vybranou dopravy a platbu pri presunu na nasledujici krok
    PayDelSelectedNextStep();

    // pokud je nahodou vybrana metoda ktera neni povolena = trida 'payment-not-enabled'
    if (
        $('input[name="delpaymentP"]:checked').length > 0 &&
        $('input[name="delpaymentP"]:checked')
            .parents("li")
            .hasClass("payment-not-enabled")
    ) {
        //najdu prvni povolenou platbu
        $('input[name="delpaymentP"]:checked')
            .parents("li")
            .removeClass("active");
        $(".ul-payment > li").each(function (i) {
            if (
                !$(this).hasClass("disabled") &&
                !$(this).hasClass("payment-not-enabled")
            ) {
                $(this).addClass("active");
                $(this).find('input[name="delpaymentP"]').prop("checked", true);
                return false;
            }
        });
    }

    $(".ul-delivery > li:not(.courier-dummy), .ul-payment > li").on(
        "click",
        function (e) {
            ClearErrorMessages();

            if (e.target != this) {
                return;
            }

            if (
                $(this).find(".pickup-external-delivery[href!='javascript:;']")
                    .length
            ) {
                $(this).find("input[type='radio']").trigger("click");
                if (
                    $("body").hasClass("body-basket") &&
                    $(".adresstype-delivery-0-8").length > 0
                ) {
                    $(".adresstype-delivery-0-8").addClass("element-hide");
                }
            } else {
                $(this).find("input[type='radio']").trigger("click");
                if (
                    $("body").hasClass("body-basket") &&
                    $(".adresstype-delivery-0-8").length > 0
                ) {
                    $(".adresstype-delivery-0-8").removeClass("element-hide");
                }
            }
        }
    );

    $(".ul-delivery > li:not(.courier-dummy) .block--info, .ul-payment > li  .block--info").on(
        "click",
        function (e) {
            if (e.target.classList.contains("fbajaxDP")) { return; }
            $(this).parents("li").trigger("click");
        });

    PayPalExpressSetVisible();

    $(document).on("click", ".fbajaxDP", function (e) {
        return AjaxFancy(e);
    });

    BindPayIco();

    //DelItemFromSessionStorage("AdyenPreparePayment");

    $("#PayuPaymentBlock table tr").has('td[colspan="3"]').hide();

    $("#PayuPaymentBlock table tr").has('td[colspan="4"]').hide();

    $("#PayuPaymentBlock table tr")
        .filter(function () {
            return (
                $(this)
                    .find("td")
                    .filter(function () {
                        return $.trim($(this).html()) === "";
                    }).length > 0
            );
        })
        .hide();

    $(document).on("click", "#adyenChangeSchemeBtn", function (e) {
        DelItemFromSessionStorage("AdyenPreparePayment");
        DelItemFromSessionStorage("AdyenPreparePayment_expire");

        if (typeof startCheckout === "function") {
            if (dropin) {
                dropin.unmount();
            }

            $("#dropin-container").html("");
            startCheckout();
        }
    });

    $(document).on("click", ".deliveryPaymentBlock .ul-delivery #CourierDummy, .deliveryPaymentBlock .ul-delivery li.courier input[name='delpaymentD']", function (e: JQuery.ClickEvent) {

        if (Fancybox.getInstance()) {
            return false;
        }

        // Najdi aktuálně vybraného kuriéra
        const $checkedCourier = $('ul.ul-delivery li.courier input[name="delpaymentD"]:checked');
        const checkedValue = $checkedCourier.val();

        const couriers = document.querySelectorAll("ul.ul-delivery li.courier");
        let htmlContent = '<div class="courier-selection-wrapper"><div class="fancybox__contentInner deliveryPaymentBlock ">' +
            '<div class="modal__header"><h3 class="title">' + GetTextDynamic("delivery_courier_name") + '</h3></div>' +
            '<div class="modal__content"><fieldset class="del-block sh">' +
            '<ul class="ul-courier-selection">';

        couriers.forEach(function (el: Element): void {
            const $ele = $(el.cloneNode(true) as HTMLElement);

            $ele.removeClass("hidden");

            // Odstraň atributy
            $ele.removeAttr("id");
            $ele.find("[id]").removeAttr("id");
            $ele.find("[for]").removeAttr("for");

            // Odstraň nežádoucí elementy
            $ele.find('input[type="hidden"]').remove();
            $ele.find(".block--info-icons").remove();
            $ele.find(".icons--all").remove();

            // Upravim nazev
            let name = $ele.find("p.carrier").text().trim();
            let $ico = $ele.find("p.name a");
            $ele.find("p.name").html(name + $ico.prop("outerHTML"));
            $ele.find("p.carrier");

            // Zachovej checked stav
            const $radio = $ele.find('input[name="delpaymentD"]');
            if (checkedValue && $radio.val() === checkedValue) {
                $radio.prop("checked", true).attr("checked", "checked");
            } else {
                $radio.prop("checked", false).removeAttr("checked");
            }
            $radio.attr("name", "delpaymentDcpy");

            htmlContent += $ele.prop("outerHTML");
        });

        htmlContent += "</ul></fieldset></div></div>";
        $.fancybox.open(htmlContent);

        return false;
    });

    $(document).on(
        "click",
        ".ul-courier-selection li",
        function (e) {
            $(".ul-courier-selection li input[name='delpaymentDcpy']:checked").prop("checked", false).removeAttr("checked");
            const delinput = $(e.currentTarget).find("input[name='delpaymentDcpy']");
            delinput.prop("checked", true).attr("checked", "checked");
            const delid = delinput.val();
            const liEl = $("li#Del" + delid.toString());
            if (liEl) {
                $("#CourierDummy").addClass("hidden");
                $(".deliveryPaymentBlock ul.ul-delivery li.courier").addClass("hidden");
                liEl.removeClass("hidden");
                liEl.removeClass("hide");
                liEl.find("input[name='delpaymentD']").trigger("click");
                liEl.find(".icons--all").addClass("hidden");
                //uložení info do session o tom že si uživatel vybral dopravu z popupu
                setCookie("crierslctd", window.location, 1);

                Fancybox.close();
            }
        }
    );
}

function PayDelSelected() {
    const del = $('input[name="delpaymentD"]').is(":checked");
    const pay = $('input[name="delpaymentP"]').is(":checked");
    let bReturn = false;
    if (del != null && del && pay != null && pay) {
        bReturn = true;
    }
    return bReturn;
}

function DeliveryExternalMethodSelected() {
    const del = $('input[name="delpaymentD"]:checked').val();
    const pay = $('input[name="delpaymentP"]:checked').val();
    const delParent = $(".ul-delivery li.active");
    const id = "pedvId" + del + "-" + pay;
    const externalEl = $("#" + id);
    let bReturn = false;

    if (
        !delParent.hasClass("external-method") ||
        delParent.hasClass("ppleveningservice")
    ) {
        // nema nastavenou externi dorucovaci metodu, nemusime kontrolovat
        // ppl denni/vecerni doruceni ma vychozi denni bez hodnoty, take nemusime kontrolovat
        bReturn = true;
    } else if (
        delParent.hasClass("external-method") &&
        externalEl.length &&
        $(externalEl).val().toString().length &&
        $(externalEl).val().toString().length > 0
    ) {
        bReturn = true;
    }
    return bReturn;
}

function ClearErrorMessages() {
    $(".pay-del-error").remove();
    if ($(".ul-delivery li.error").length > 0)
        $(".ul-delivery li.error").removeClass("error");
}
function PayDelSelectedNextStep() {
    $("#navistep .step-" + (bpdStep + 1) + " a, #buttonnextprew a").each(
        function () {
            // je zde moznost odeslani objednavky, musime odstranit attr onclick,
            // aby jsme mohli provest kontrolu na vybranou dopravu a nebo vybrane misto odberu
            if ($(this).is("[onclick]")) {
                $(this).attr("submit", $(this).attr("onclick"));
                $(this).removeAttr("onclick");
            }
        }
    );

    $(document).on(
        {
            click: function (e) {
                ClearErrorMessages();

                if (!$(this).hasClass("info--buttons__prew")) {
                    if (!PayDelSelected()) {
                        // kontrola na vybranou dopravy a platbu
                        e.preventDefault();
                        $(
                            "<div class='alert alert-danger pay-del-error' >" +
                            GetTextDynamic(
                                "basket_check_error_delpayment"
                            ) +
                            "</div>"
                        ).insertAfter("#buttonnextprew");
                        if ($("body.is-mobile").length > 0) {
                            $("html, body").animate(
                                {
                                    scrollTop:
                                        $("#basketSumPriceBox").offset().top,
                                },
                                100
                            );
                        }

                        return false;
                    } else if (!DeliveryExternalMethodSelected()) {
                        // kontrola na vybranou externi dorucovaci metodu u dopravy
                        e.preventDefault();

                        $(
                            "<div class='alert alert-danger pay-del-error' >" +
                            GetTextDynamic(
                                "basket_check_error_del_external"
                            ) +
                            "</div>"
                        ).insertAfter("#buttonnextprew");
                        if ($("body.is-mobile").length > 0) {
                            $("html, body").animate(
                                {
                                    scrollTop:
                                        $("#basketSumPriceBox").offset().top,
                                },
                                100
                            );
                        }
                        return false;
                    }

                    if (
                        $("input[name='PickupDate']").length &&
                        $('input[name="delpaymentD"]:checked').attr(
                            "personal"
                        ) == "1"
                    ) {
                        // kontrola na vyplneni osobniho vyzvednuti
                        const delDate = $("input[name='PickupDate']");
                        const delTime = $("select[name='PickupTime']");

                        if (!delDate.val() || !delTime.val()) {
                            e.preventDefault();
                            $(
                                "<div class='alert alert-danger pay-del-error'>" +
                                GetTextDynamic(
                                    "basket_check_error_personal"
                                ) +
                                "</div>"
                            ).insertAfter("#buttonnextprew");
                            if ($("body.is-mobile").length > 0) {
                                $("html, body").animate(
                                    {
                                        scrollTop:
                                            $("#basketSumPriceBox").offset()
                                                .top,
                                    },
                                    100
                                );
                            }
                            return false;
                        }
                    }

                    if (
                        $('input[name="delpaymentP"]').length > 0 &&
                        $(".paypal-button-container").length > 0
                    ) {
                        if (
                            $('input[name="delpaymentP"][pet="PayPalExpress"]')
                                .length > 0
                        ) {
                            if (
                                $(
                                    'input[name="delpaymentP"][pet="PayPalExpress"]'
                                ).is(":checked")
                            ) {
                                return false;
                            }
                        }
                    }

                    if (
                        $('input[name="delpaymentP"]').length > 0 &&
                        $(".dropin-inline").length > 0 &&
                        $("#adyenChangeSchemeBtn").length == 0
                    ) {
                        if (
                            $('input[name="delpaymentP"][pet="adyen"]').length >
                            0 &&
                            typeof dropin !== "undefined"
                        ) {
                            const adyenPaymentParent =
                                $(".dropin-inline").parent();
                            const adyenPaymentInput = adyenPaymentParent.find(
                                'input[name="delpaymentP"][pet="adyen"]'
                            );

                            if (adyenPaymentInput.is(":checked")) {
                                const adyenPrepared = GetItemFromSessionStorage(
                                    "AdyenPreparePayment"
                                );

                                if (
                                    adyenPrepared != null &&
                                    adyenPrepared.length > 0
                                ) {
                                    if (
                                        adyenPaymentParent.find(
                                            ".adyen-checkout__input--error"
                                        ).length > 0
                                    ) {
                                        return false;
                                    }
                                } else {
                                    dropin.submit();

                                    setTimeout(function () {
                                        if (
                                            $("#dropin-box").find(
                                                '[class*="error"]'
                                            ).length > 0
                                        ) {
                                            return;
                                        } else if (
                                            $(".info--buttons__next").attr(
                                                "href"
                                            ) &&
                                            $(".info--buttons__next").attr(
                                                "href"
                                            ).length > 0 &&
                                            (typeof $(
                                                ".info--buttons__next"
                                            ).attr("onclick") === "undefined" ||
                                                $(".info--buttons__next").attr(
                                                    "onclick"
                                                ).length == 0)
                                        ) {
                                            window.location.href = $(
                                                ".info--buttons__next"
                                            ).attr("href");
                                        }
                                    }, 500);

                                    return false;
                                }
                            }
                        }
                    }
                }

                if ($(this).is("[submit]")) {
                    // vse v poradku, odesleme objednavku
                    eval($(this).attr("submit"));
                }
            },
        },
        "#navistep .step-" +
        (bpdStep + 1) +
        " a, #buttonnextprew a, #buttonnextprew form button, .sendorderbtn button"
    );
}

function checkExternalPayments() {
    if ($("#PayuPaymentBlock").length) {
        $("#PayuPaymentBlock").hide();
        if ($('input[name="delpaymentP"]:checked').attr("pet") == "payu") {
            $('input[name="delpaymentP"]:checked')
                .parents("li")
                .find("#PayuPaymentBlock")
                .show();
        }
    }
}

// vybere dopravu, pokud je jen jedina mozna
function checkSingleDelivery() {
    if ($(".ul-delivery>li:visible").length == 1) {
        const el = $(".ul-delivery>li:visible>input").attr("id");
        //$("#" + el).prop("checked", true)
        $("#" + el).click();
        setPayment();
    }
}

// vybere platbu, pokud je jen jedina mozna
function checkSinglePayment() {
    if ($(".ul-payment>li:visible").length == 1) {
        const el = $(".ul-payment>li:visible>input").attr("id");
        $("#" + el).prop("checked", true);
    }
}

function checkExternalDelivery() {
    if (!externalMethodToFancy) {
        // pokud externi dorucovaci metody jsou zobrazeny pod dopravou, nikoliv ve fancyboxu
        $(".ajax-load-choice").remove();
    }

    // Ulozenka
    if (
        $('input[name="delpaymentD"]:checked')
            .parent()
            .children(".ulozenkaIcoHelp").length > 0
    ) {
        $(".ulozenkaIcoHelp").trigger("click");
    } else {
        $("#ulozenkaInfo").hide();
        //Zobrazime veskere dodaci adresy
        $(".adresstype-delivery-0-8").removeClass("element-hide");
    }

    // Meest
    if (
        $('input[name="delpaymentD"]:checked')
            .parent()
            .children(".meestIcoHelp").length > 0
    ) {
        $(".meestIcoHelp").trigger("click");
    } else {
        $("#meestInfo").hide();
        //Zobrazime veskere dodaci adresy
        $(".adresstype-delivery-0-8").removeClass("element-hide");
    }

    // Meest postomat
    if (
        $('input[name="delpaymentD"]:checked')
            .parent()
            .children(".meestPostomatIcoHelp").length > 0
    ) {
        $(".meestPostomatIcoHelp").trigger("click");
    } else {
        $("#meestPostomatInfo").hide();
        //Zobrazime veskere dodaci adresy
        $(".adresstype-delivery-0-8").removeClass("element-hide");
    }

    // Nova Posta
    if (
        $('input[name="delpaymentD"]:checked')
            .parent()
            .children(".novapostaIcoHelp").length > 0
    ) {
        $(".novapostaIcoHelp").trigger("click");
    } else {
        $("#novapostaInfo").hide();
        //Zobrazime veskere dodaci adresy
        $(".adresstype-delivery-0-8").removeClass("element-hide");
    }

    // Pobočky
    if (
        $('input[name="delpaymentD"]:checked')
            .parent()
            .children(".pobockyIcoHelp").length > 0
    ) {
        $(".pobockyIcoHelp").trigger("click");
    } else {
        $("#pobockaInfo").hide();
    }

    // ZasilkovnaExt Office
    ExternalDeliveryLinkFunctionCheck(
        "zasilkovnaextParcelIcoHelp",
        "zasilkovnaextparcelinfo"
    );

    // PPLparcelshop
    ExternalDeliveryLinkFunctionCheck("pplParcelIcoHelp", "pplparcelinfo");

    // Meest
    ExternalDeliveryLinkFunctionCheck("meestIcoHelp", "meestinfo");

    // Nova posta
    ExternalDeliveryLinkFunctionCheck("novapostaIcoHelp", "novapostainfo");

    // Meest postomat
    ExternalDeliveryLinkFunctionCheck(
        "meestPostomatIcoHelp",
        "meestpostomatinfo"
    );

    // DPDparcelshop
    ExternalDeliveryLinkFunctionCheck("dpdParcelShopIcoHelp", "dpdparcelinfo");

    // GLSparcelshop
    ExternalDeliveryLinkFunctionCheck("glsParcelShopIcoHelp", "glsparcelinfo");

    // PostOffice
    ExternalDeliveryLinkFunctionCheck("postOfficeIcoHelp", "napostuinfo");

    // Balikovna
    ExternalDeliveryLinkFunctionCheck("balikovnaIcoHelp", "balikovnainfo");

    // Balikobox
    ExternalDeliveryLinkFunctionCheck("balikoboxIcoHelp", "balikoboxinfo");

    // zasilkovna
    ExternalDeliveryLinkFunctionCheck("zasilkovnaIcoHelp", "zasilkovnainfo");

    // sps
    ExternalDeliveryLinkFunctionCheck("spsIcoHelp", "spsinfo");

    // Postoffice package
    ExternalDeliveryLinkFunctionCheck(
        "postofficepackageIcoHelp",
        "postofficeautomat"
    );

    // ppl
    ExternalDeliveryLinkFunctionCheck("pplevening", "ppleveningservice");

    // deliverypoint
    ExternalDeliveryLinkFunctionCheck(
        "deliveryPointIcoHelp",
        "deliverypointinfo"
    );

    // cas doruceni
    if (
        $('input[name="delpaymentD"]:checked')
            .parent()
            .find(".deliverytimeIcoHelp").length
    ) {
        $(".deliverytimeIcoHelp").trigger("click");
    } else {
        $("#deliverytime-selected").hide().html("");
        $(".deliverytime-zip-allow").removeClass("deliverytime-zip-allow");
    }

    // ceska posta cas doruceni
    if (
        $('input[name="delpaymentD"]:checked')
            .parent()
            .find(".postdeliveryzoneIcoHelp").length
    ) {
        $(".postdeliveryzoneIcoHelp").trigger("click");
    } else {
        $("#postdeliveryzone-selected").hide().html("");
        $(".postdeliveryzone-zip-allow").removeClass(
            "postdeliveryzone-zip-allow"
        );
    }

    //// ostatní dopravy s widgetem
    //if ($('input[name="delpaymentD"]:checked').parent().find("a[class*='deliveryPointIcoHelp']").length) {
    //    $('input[name="delpaymentD"]:checked').parent().find("a[class*='deliveryPointIcoHelp']")
    //        .first().triggerHandler('click');
    //}

    $(".delivery-info").hide();

    // Inpost Paczkomat
    ExternalDeliveryLinkFunctionCheck(
        "inpostPaczkomatIcoHelp",
        "inpostpaczkomatinfo"
    );

    // PostNord
    ExternalDeliveryLinkFunctionCheck(
        "postNordIcoHelp",
        "postnordinfo"
    );
}

function ExternalDeliveryLinkFunctionCheck(itemClass, hideID) {
    if (
        $('input[name="delpaymentD"]:checked')
            .parent()
            .find("." + itemClass).length > 0
    ) {
        const anchor = $('input[name="delpaymentD"]:checked')
            .parent()
            .find("." + itemClass);
        const classes = anchor.attr("class").split(" ");
        const pedvId = classes[1];
        ExternalDeliveryLinkFunction(anchor, pedvId, null, true);
    } else {
        $("#" + hideID).hide();
    }
}

let serPrev = "";
let $loadAjaxSavePayDel = null;

function savepaydel(forceRequest?: boolean) {
    forceRequest = typeof forceRequest !== "undefined" ? forceRequest : false;

    if ($loadAjaxSavePayDel) {
        $loadAjaxSavePayDel.abort();
    }

    if ($("#DelPayNoContrModul").hasClass("updating") && !forceRequest) return;

    let pev = "";
    let pedv = "";
    let sur = 0;
    let sdelinfo = "";
    let personalPickup = "";
    const delObj = $("input[name='delpaymentD']:checked");
    const payObj = $("input[name='delpaymentP']:checked");
    const payVal = payObj.val();
    const delVal = delObj.val();

    ///promenna z 3 kroku
    if (typeof pagebaseDelId !== "undefined") {
        pagebaseDelId = Number(delVal);
    }

    // pridani classu pro parenta aktivniho prvku dopravy a platby
    $(".ul-delivery li, .ul-payment li").removeClass("active");
    $(".pay-del-error").remove();
    $("#Del" + delVal).addClass("active");
    $("#Pay" + payVal).addClass("active");

    if ($("#pevId" + delVal + "-" + payVal).length) {
        if ($("#pevId" + delVal + "-" + payVal).val() > "") {
            pev = $("#pevId" + delVal + "-" + payVal)
                .val()
                .toString();
        }
    }

    if ($("input[id*=pedvId" + delVal + "]").length) {
        if ($("input[id*=pedvId" + delVal + "]").val() > "") {
            pedv = $("input[id*=pedvId" + delVal + "]")
                .val()
                .toString();
        } else {
            $("input[name=pedv]").val("");
            // Je treba anulovat linky pro jednotlive sluzby. Jde o to ze v pripade kliku na jinou dopravu se vynuluje zaznam v db link zustava jako 3ka tzn vybrat predvybrany detail a pak to nabizi 2 selecty naraz.
            if ($(".pplParcelIcoHelp").length > 0)
                $(".pplParcelIcoHelp").attr(
                    "href",
                    "/ajax/layerContent.aspx?type=pplparcelshop&mode=1&ps="
                );

            if ($(".zasilkovnaextParcelIcoHelp").length > 0) {
                $(".zasilkovnaextParcelIcoHelp").each(function () {
                    const carrierId = $(this)
                        .closest(".external-method")
                        .find("input[name='delpaymentD']")
                        .data("carrierid");
                    $(this).attr(
                        "href",
                        "/ajax/layerContent.aspx?type=zasilkovnaextparcelshop&mode=1&carrierId=" +
                        carrierId +
                        "&ps="
                    );
                });
            }

            if ($(".upsIcoHelp").length > 0)
                $(".upsIcoHelp").attr(
                    "href",
                    "/ajax/layerContent.aspx?type=ups&mode=1&ps="
                );

            if ($(".pobockyIcoHelp").length > 0)
                $(".pobockyIcoHelp").attr(
                    "href",
                    "/ajax/layerContent.aspx?type=dispensingpoints&mode=1&ps="
                );

            if ($(".inpostPaczkomatIcoHelp").length > 0)
                $(".inpostPaczkomatIcoHelp").attr(
                    "href",
                    "/ajax/layerContent.aspx?type=inpostpaczkomat&mode=1&ps="
                );

            if ($(".postNordIcoHelp").length > 0)
                $(".postNordIcoHelp").attr(
                    "href",
                    "/ajax/layerContent.aspx?type=postnord&mode=1&ps="
                );            
        }
    } else {
        $("input[name=pedv]").val("");
        // Je treba anulovat linky pro jednotlive sluzby. Jde o to ze v pripade kliku na jinou dopravu se vynuluje zaznam v db link zustava jako 3ka tzn vybrat predvybrany detail a pak to nabizi 2 selecty naraz.
        if ($(".pplParcelIcoHelp").length > 0)
            $(".pplParcelIcoHelp").attr(
                "href",
                "/ajax/layerContent.aspx?type=pplparcelshop&mode=1&ps="
            );

        if ($(".zasilkovnaextParcelIcoHelp").length > 0) {
            $(".zasilkovnaextParcelIcoHelp").each(function () {
                const carrierId = $(this)
                    .closest(".external-method")
                    .find("input[name='delpaymentD']")
                    .data("carrierid");
                $(this).attr(
                    "href",
                    "/ajax/layerContent.aspx?type=zasilkovnaextparcelshop&mode=1&carrierId=" +
                    carrierId +
                    "&ps="
                );
            });
        }

        if ($(".upsIcoHelp").length > 0)
            $(".upsIcoHelp").attr(
                "href",
                "/ajax/layerContent.aspx?type=ups&mode=1&ps="
            );

        if ($(".pobockyIcoHelp").length > 0)
            $(".pobockyIcoHelp").attr(
                "href",
                "/ajax/layerContent.aspx?type=dispensingpoints&mode=1&ps="
            );

        if ($(".inpostPaczkomatIcoHelp").length > 0)
            $(".inpostPaczkomatIcoHelp").attr(
                "href",
                "/ajax/layerContent.aspx?type=inpostpaczkomat&mode=1&ps="
            );

        if ($(".postNordIcoHelp").length > 0)
            $(".postNordIcoHelp").attr(
                "href",
                "/ajax/layerContent.aspx?type=postnord&mode=1&ps="
            );        
    }

    ExternalDeliveryPointReset();

    if ($("input[id*=surId" + delVal + "]").length) {
        if ($("input[id*=surId" + delVal + "]").val() > "") {
            sur = Number(
                $("input[id*=surId" + delVal + "]")
                    .val()
                    .toString()
            );
        }
    }

    if (
        $("li.external-method.zasilkovna.active").length > 0 &&
        $(".packeta-selector-branch-place").length > 0
    ) {
        sdelinfo = $(".packeta-selector-branch-place").val().toString(); // zde si ukladam informace z packety zda se jedna o alza nebo z-box
    }

    // datum a cas vyzvednuti zbozi pri osobnim odberu
    if ($(".pickupDate").length) {
        const id = $('input[name="delpaymentD"]:checked').val();
        if (
            $("#PickupDate" + id).length &&
            $("#PickupDate" + id)
                .val()
                .toString().length &&
            $("input[name='delpaymentD']:checked").is("[personal]")
        ) {
            // datum vyzvednuti pro osobni odber
            personalPickup =
                $("#PickupDate" + id).val() +
                ($("#PickupTime" + id).val() != null
                    ? " " + $("#PickupTime" + id).val()
                    : "");
        } else if (
            $("#PickupDate" + id).length &&
            !$("input[name='delpaymentD']:checked").is("[personal]")
        ) {
            personalPickup = "";
        }
        if ($("input[name='delpaymentD']:checked").is("[personal]")) {
            $(".pickupDate").show();
        } else {
            $(".pickupDate").hide();
        }
    }
    const di = sdelinfo;
    const bAction = $("body").hasClass("body-basket")
        ? "basket"
        : $("body").hasClass("basket-cd")
            ? "basket-2"
            : "basket-3";

    const values = [delVal, payVal, pev, pedv, sur, di, personalPickup, lang, bAction];

    const ser = {
        con: 0,
        del: values[0],
        pay: values[1],
        pev: values[2],
        pedv: values[3],
        sur: values[4],
        delinfo: values[5],
        personalPickup: values[6],
        lang: values[7],
        a: values[8],
    };

    let sser = values.join("|");

    let setvat = "";
    if (
        !(typeof $BasketFullPage === "undefined" || $BasketFullPage === null) &&
        $BasketFullPage == "1"
    ) {
        if ($vatPayer != null) {
            sser = sser + "|" + $vatPayer;
            setvat = "?setvat=" + $vatPayer;
        }
    }

    if (sser == serPrev && !forceRequest) {
        //kontrola zda je externi doprava, pokud ano pak zda ma vybranou pobocku        
        if (
            $('.delivery-info[data-id="' + delVal + '"]').length === 0 ||
            ($('.delivery-info[data-id="' + delVal + '"]').length > 0 &&
                $('.delivery-info[data-id="' + delVal + '"]').is(":visible"))
        ) {
            // console.log('is the same, return');
            return;
        }
    }

    //kontrola sdružených doprav - deliverypoint zda mají vybranou pobočku
    if ($(delObj).closest("li").hasClass("deliverypoint")
        &&
        Number(pedv) == 0
    ) {
        //neukladam
        return;
    }

    serPrev = sser;

    //ulozeni volby a aktualizace dat na strance
    $loadAjaxSavePayDel = $.ajax({
        type: "GET",
        url: "/Pages/DeliverySave.aspx" + setvat,
        cache: false,
        data: ser,
        dataType: "json",
        complete: function () {
            $loadAjaxSavePayDel = null;
        },
        success: function (json) {
            processBasketJson(json);
            setAdrressInputValidation();
            if (typeof ZipIsAllowedAll === "function") {
                ZipIsAllowedAll();
            }
        },
    });
}

function writeDPprice() {
    const idD = $('input[name="delpaymentD"]:checked').val();
    const idP = $('input[name="delpaymentP"]:checked').val();

    $("#deliveryPriceCurrent").html(
        $("#dpPrice" + idD + "-" + idP)
            .val()
            .toString()
    );
    $("#deliveryPriceWithVatCurrent").html(
        $("#dpPricevat" + idD + "-" + idP)
            .val()
            .toString()
    );
}

function setPayment() {
    let firstID = 0;
    const idD = $('input[name="delpaymentD"]:checked').val();
    const idP = Number($('input[name="delpaymentP"]:checked').val());
    const idPName = $('input[name="delpaymentP"]:checked').attr("data-name"); //nazev dane platby
    const dpVazba = $("#dpVazba").val().toString().split(";");
    let idPAllowedWithTheSameName = 0; // dohleda nove povolenou platbu se stejnym jmenem.

    disabledAllPayment();

    let canStillUseMyPayment = false;

    $.each(dpVazba, function (index, value) {
        const $idDopravy = value.split(":")[0];
        const $ids = value.split(":")[1];

        if (idD == $idDopravy) {
            $.each($ids.split(","), function (index, value) {
                const item = $(
                    'input[name="delpaymentP"][value="' + value + '"]'
                );
                const itemName = $(item).attr("data-name");
                if (!$(item).parents("li").hasClass("payment-not-enabled")) {
                    if (firstID == 0 && Number(value) > 0) {
                        firstID = Number(value);
                    }
                    $(item).removeAttr("disabled");
                    $(item)
                        .parents("li")
                        .removeClass("disabled")
                        .removeClass("hide");
                    $(item)
                        .parent()
                        .parent()
                        .removeClass("disabled")
                        .removeClass("hide");

                    if (idP == Number(value) && Number(value) > 0) {
                        canStillUseMyPayment = true;
                        firstID = idP;
                    } else if (itemName == idPName) {
                        idPAllowedWithTheSameName = Number(value);
                    }
                }
            });
        }
    });

    //pokud nemohu pouzit stavajici platbu zkusim dohledat jinou se stejnym nazvem - pokud ani toto nezabere
    if (!canStillUseMyPayment && idPAllowedWithTheSameName > 0)
        firstID = idPAllowedWithTheSameName;

    if ($('input[name="delpaymentP"]:checked').attr("disabled") == "disabled") {
        $('input[name="delpaymentP"]:checked').removeAttr("checked");
        $('input[name="delpaymentP"][value="' + firstID + '"]').prop(
            "checked",
            true
        );
    }

    $.each(jsVariablePaymentPrices.split("|"), function (index, item) {
        if (idD == item.split("~")[0]) {
            const idPay = item.split("~")[1];
            const priceDiff = item.split("~")[2];
            let val = item.split("~")[3];
            const dif = $("#Pay" + idPay).find(".diff");
            if ($(dif).attr("rel").length > 0 && parseFloat(priceDiff) == 0) {
                // cena je 0 a mam nadefinovany text, zdarma
                val = $(dif).attr("rel");
            }
            if (dif != null) {
                dif.html(val);
            }
        }
    });
    checkSinglePayment();
}

function disabledAllPayment() {
    $('input[name="delpaymentP"]').attr("disabled", "disabled");
    $("li", ".ul-payment")
        .not(".adyen-checkout__payment-method")
        .each(function (index) {
            if (!$(this).hasClass("disabled")) {
                $(this).addClass("disabled");
            }

            $(this).addClass("hide");
        });
}

//zpracovani json se seznamem plateb a doprav
function processBasketDeliveryPayment(json) {
    if ($(".deliveryPaymentBlock").length === 0) return;

    let d = []; //seznam doprav na strance
    $('.ul-delivery li input[name="delpaymentD"]').each(function (i) {
        d.push($(this).val());
    });
    let p = []; //seznam plateb na strance
    $('.ul-payment li input[name="delpaymentP"]').each(function (i) {
        p.push($(this).val());
    });

    let items = json.dList;
    let dpointPrices = new Map<number, string>();
    let courierPrices = new Map<number, string>();
    let dpointDates = new Map<number, string>();
    let courierDates = new Map<number, string>();
    let dpointCountPoints: number = 0;

    //ikony u sdružených doprav označím hromadně jako hide a pak jen aktivním odeberu
    $(".ul-delivery li .icons.icons--all img").addClass("hide");

    $(items).each(function (i, val) {
        const id = items[i].Id;
        const li = $("#Del" + id);

        if ($(li).length > 0) {
            if (items[i].Enabled) {
                $(li).removeClass("hide");
                if (!$(li).hasClass("deliverypoint") && !$(li).hasClass("courier")) {
                    $(li).removeClass("hidden");
                }
                //ikonka u sdružených doprav
                $(".delIco" + id).removeClass("hide");
            }
            else {
                $(li).addClass("hide");
            }

            if (items[i].Enabled) {
                //ceny
                const priceobj = $(li).find("span.price").not(".price-from");
                priceobj.html(items[i].sPriceWithVat);
                //datumy
                const dateobj = $(li).find("[data-date]");

                if ($(li).hasClass("deliverypoint")) {
                    dpointPrices.set(items[i].PriceWithVat, items[i].sPriceWithVat);

                    if (dateobj.length > 0) {
                        const datevalue = Number(dateobj.attr("data-date"));
                        const datestring = dateobj.attr("data-sdate");
                        dpointDates.set(datevalue, datestring);
                    }

                    dpointCountPoints += $(li).find("[data-countpoints]").first().data("countpoints");

                }
                if ($(li).hasClass("courier")) {
                    courierPrices.set(items[i].PriceWithVat, items[i].sPriceWithVat);

                    if (dateobj.length > 0) {
                        const datevalue = Number(dateobj.attr("data-date"));
                        const datestring = dateobj.attr("data-sdate");
                        courierDates.set(datevalue, datestring);
                    }
                }


                if (items[i].IsFree) priceobj.addClass("free");
                else li.find("label.price").removeClass("free");
            }

            if (items[i].IsWithBoxes) li.addClass("with-boxes");
            else li.removeClass("with-boxes");
        }

        //mazu ze seznamu dopravu, ktera je v json
        d = jQuery.grep(d, function (value) {
            return value != id;
        });
    });

    //pro sloučené dopravy deliverypoint a courier aktualizuju cenu od
    //deliverypoint
    if (dpointPrices.size > 0) {
        const minPrice = Math.min(...Array.from(dpointPrices.keys()));
        const minPriceHtml = (minPrice > 0 ? GetTextDynamic("basket_popup_delivery_from") + " " : "") + dpointPrices.get(minPrice);

        $(".ul-delivery li.deliverypoint").each(function (index, li) {
            const priceObj = $(li).find("span.price.price-from");
            priceObj.html(minPriceHtml);
            if (minPrice! > 0) { priceObj.addClass("free"); }
            else { priceObj.removeClass("free"); }
        });
    }

    // Stejně pro courier
    if (courierPrices.size > 0) {
        const minPrice = Math.min(...Array.from(courierPrices.keys()));
        const minPriceHtml = (minPrice > 0 ? GetTextDynamic("basket_popup_delivery_from") + " " : "") + courierPrices.get(minPrice);

        $(".ul-delivery li.courier-dummy").each(function (index, li) {
            const priceObj = $(li).find("span.price.price-from");
            priceObj.html(minPriceHtml);
            if (minPrice! > 0) { priceObj.addClass("free"); }
            else { priceObj.removeClass("free"); }
        });
    }

    //pro sloučené dopravy deliverypoint a courier aktualizuju datumy
    if (dpointDates.size > 0) {
        const minDate = Math.min(...Array.from(dpointDates.keys()));
        const maxDate = Math.max(...Array.from(dpointDates.keys()));
        const sdateMin = dpointDates.get(minDate)!;
        const sdateMax = dpointDates.get(maxDate)!;

        const template: string = GetTextDynamic("paydel_delivery_date");
        const dateRange: string = sdateMin === sdateMax
            ? sdateMin
            : `${sdateMin} — ${sdateMax}`;

        const datesInfo: string = template.replace("$DATUM$", dateRange);
        $(".ul-delivery li.deliverypoint").each(function (index, li) {
            $(li).find(".delivery.date").not(".orig").html(datesInfo);
        });
    }

    if (courierDates.size > 0) {
        const minDate = Math.min(...Array.from(courierDates.keys()));
        const maxDate = Math.max(...Array.from(courierDates.keys()));
        const sdateMin = courierDates.get(minDate)!;
        const sdateMax = courierDates.get(maxDate)!;

        const template: string = GetTextDynamic("paydel_delivery_date");
        const dateRange: string = sdateMin === sdateMax
            ? sdateMin
            : `${sdateMin} — ${sdateMax}`;

        const datesInfo: string = template.replace("$DATUM$", dateRange);
        $(".ul-delivery li.courier-dummy").each(function (index, li) {
            $(li).find(".delivery.date").not(".orig").html(datesInfo);
        });
    }

    //aktualizuju počet odběrných míst
    $("deliverypointinfoorig").each(function (index, o) {
        $(o).html(
            GetTextDynamic("delivery_point_count").replace("#count#", dpointCountPoints.toLocaleString())
        )
    });


    items = json.pList;
    $(items).each(function (i, val) {
        const id = items[i].Id;
        const li = $("#Pay" + id);
        if ($(li).length > 0) {
            if (items[i].Enabled && !$(li).hasClass("payment-not-enabled")) {
                $(li).removeClass("hide");
                $(li).removeClass("hidden");
            } else $(li).addClass("hide");

            $(li).find("span.price").html(items[i].sPriceWithVat);
            if (items[i].IsFree) li.find("span.price").addClass("free");
            else li.find("span.price").removeClass("free");
        }

        //mazu ze seznamu plpatbu, ktera je v json
        p = jQuery.grep(p, function (value) {
            return value != id;
        });
    });

    //to co zbylo musim skryt
    $(d).each(function (i, v) {
        const id = "#Del" + v;
        $(id).addClass("hide").removeClass("active");
    });
    $(p).each(function (i, v) {
        const id = "#Pay" + v;
        $(id).addClass("hide").removeClass("active");
    });

    // kontrola nyni je oznaceno a ma byt oznaceno dle json
    let changed = false;

    $("#DelPayNoContrModul").addClass("updating");
    if (
        json.Delivery != null &&
        json.Delivery.Id > 0 &&
        $('input[name="delpaymentD"]:checked').val() != json.Delivery.Id
    ) {
        const IdDelivery = CorrectIdByVisibility("Del", json.Delivery.Id);
        if (IdDelivery > 0) {
            $("#DelSub" + IdDelivery).prop("checked", true);
            changed = true;
        } else {
            console.log("Delivery is 0");
        }
    }
    if (
        json.Payment != null &&
        $('input[name="delpaymentP"]:checked').val() != json.Payment.Id
    ) {
        const IdPayment = CorrectIdByVisibility("Pay", json.Payment.Id);
        if (IdPayment > 0) {
            $("#PaySub" + IdPayment).prop("checked", true);
            changed = true;
        } else {
            console.log("Payment is 0");
        }
    }
    if (changed) {
        setPayment();
        savepaydel(true);
    }
    $("#DelPayNoContrModul").removeClass("updating");

    if (json.Delivery != null) {
        $("#hSelDelWithoutAddress").val(
            json.Delivery.DeliveryWithoutAddress ? "1" : "0"
        );
    }

    //korekce zobraz skryj
    const pD = $('.ul-delivery li[id^="Del"]').not(".hide").length;
    const pP = $('.ul-payment li[id^="Pay"]').not(".hide").length;

    if (pD > 3) $(".del-block .block--show").removeClass("hidden");
    else {
        $(".del-block sh").addClass("active");
        $(".del-block .block--show").addClass("hidden");
    }

    if (pP > 3) $(".paym-block.block--show").removeClass("hidden");
    else {
        $(".pay-block sh").addClass("active");
        $(".paym-block .block--show").addClass("hidden");
    }

    //nastavim tridy dynamic
    if (pD > 3 && $(".del-block .block--show").length > 0) {
        $('.ul-delivery li[id^="Del"]')
            .not(".hide")
            .each(function (i, v) {
                if (i >= 3) SetDynamic($(this), true, false);
                else SetDynamic($(this), false, false);
            });
    }
    if (pP > 3 && $(".paym-block .block--show").length > 0) {
        $('.ul-payment li[id^="Pay"]')
            .not(".hide")
            .each(function (i, v) {
                if (i >= 3) SetDynamic($(this), true, false);
                else SetDynamic($(this), false, false);
            });
    }

    //pokud je
    if ($('.ul-delivery li[id^="Del"].dynamic.active').length > 0) {
        $(".del-block sh").addClass("active");
    }
    if ($('.ul-payment li[id^="Pay"].dynamic.active').length > 0) {
        $(".paym-block sh").addClass("active");
    }
}

//pro pripad ze dane ID neni na obrazovce - at se nam system nezacykli
function CorrectIdByVisibility(prefix, id) {
    let retId = id;
    if (
        $("#" + prefix + id).length == 0 ||
        !$("#" + prefix + id).is(":visible")
    ) {
        if (
            $('.deliveryPaymentBlock li[id^="' + prefix + '"]:visible:not(.deliverypoint)').length >
            0
        )
            retId = $('.deliveryPaymentBlock li[id^="' + prefix + '"]:visible')
                .eq(0)
                .attr("id")
                .replace(prefix, "");
        else retId = 0;
    }
    return retId;
}

function SetDynamic(o, setOn, anim) {
    if (setOn) {
        $(o).addClass("dynamic");
    } else {
        $(o).removeClass("dynamic");
    }

    SetDynamicShowHide(o, setOn, anim);
}
function SetDynamicShowHide(o, setOn, anim) {
    //console.log('SetDynamicShowHide id=' + $(o).attr('id') + ', ' + setOn + ', ' + anim);
    const t = anim ? 100 : 0;
    if (setOn && !$(o).hasClass("active")) {
        $(o).hide(t);
    } else if (!$(o).hasClass("hide")) {
        $(o).slideDown("fast");
    }
}

function BindPayIco() {
    $(document).on("click", ".table-payu img", function (e) {
        $(this).parents("td").prev().find("input").trigger("click");
    });
}

function ExternalDeliveryPointReset() {
    //reset vybraného kurýra
    //pouze pokud některý není vybrán
    if (!$("ul.ul-delivery li.courier.active").length) {
        $("ul.ul-delivery li.courier").not(".hidden").each((index, element) => {
            $(element).addClass("hidden");
        });

        $("ul.ul-delivery li.courier-dummy").removeClass("hidden");
    }

    //reset vybraného místa
    $("ul.ul-delivery li.external-method.deliverypoint:not(.active)")
        .not(".hidden")
        .each((index, element) => {
            $(element).find(".deliverypointinfo").addClass("hidden");
            $(element).find(".deliverypointinfoorig").removeClass("hidden");
            $(element).find(".delivery.date.orig").addClass("hidden");
            $(element)
                .find(".delivery.date")
                .not(".orig")
                .removeClass("hidden");
            $(element).find(".icons--all").removeClass("hidden");
            $(element).find(".price").addClass("hidden");
            $(element).find(".price-from").removeClass("hidden");
            $(element).find(".choose-other-service").addClass("hidden");
            const img = $(element).find(".delivery-point-img");
            const imgsrc = img.attr("data-orig-src");
            const imgalt = img.attr("data-orig-alt");
            img.find("img").attr("src", imgsrc);
            img.find("img").attr("alt", imgalt);
        });
}
